<form #loginForm="ngForm" (ngSubmit)="onLoginClick(loginForm)">
    <ion-card-content class="ion-no-padding">

        <ion-list lines="none" class="ion-padding">
            <ion-item>
                <ion-label position="stacked">Email</ion-label>
                <ion-input fill="solid" type="email" [(ngModel)]="user.email" name="email" data-test="email" required #email></ion-input>
            </ion-item>

            <ion-item>
                <ion-grid class="ion-no-padding">
                    <ion-row>
                        <ion-col size="auto">
                            <ion-label class="ion-text-wrap" position="stacked">Password</ion-label>
                            <ion-input fill="solid" type="password" [(ngModel)]="user.password" data-test="password" name="password"
                                #password="ngModel" required
                                [ngClass]="{ 'is-invalid': loginForm.submitted && password.invalid }">
                            </ion-input>
                        </ion-col>
                        <ion-col size="1">
                            <ion-button class="itemButton" color="primary" expand="full" fill="solid" id="eye"
                                (click)="onEyeClick()" data-test="eye">
                                <ion-icon name="eye-sharp"></ion-icon>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-grid>

                @if (submitted && password.invalid) {
                    <div data-test="passwordErr" class="validationErrorMsg">
                        Password must be at leasts 6 charcters.
                    </div>
                }                
            </ion-item>


            <ion-button color="primary" expand="block" [disabled]="!loginForm.valid" class="loginBtn ion-padding"
                #loginButton (click)="onLoginClick(loginForm)" data-test="loginBtn">
                {{vm.loginText}}
            </ion-button>

        </ion-list>
    </ion-card-content>
</form>